import { SlidersPerView } from '~/enums'

export const LIMIT_HOTMATCH_ITEM = 2

export const FIRST_HOTMATCH_ITEM = 1
export const IMAGE_HOTMATCH_DEFAULT: string =
  '/images/hotmatch/flag-default.png'

export const HOTMATCH_SWIPER_OPTIONS = {
  slidesPerView: SlidersPerView.Auto,
  spaceBetween: 0,
  slidesPerGroup: 1,
  grabCursor: true,
  mousewheel: false,
  observer: true,
  observeParents: true,
  loop: false,
  slidesOffsetAfter: 2
}

export const HOTMATCH_MB_SWIPER_OPTIONS = {
  slidesPerView: 1.05,
  spaceBetween: 8,
  slidesPerGroup: 1,
  grabCursor: true,
  mousewheel: false,
  observer: true,
  observeParents: true,
  loop: true,
  breakpoints: {
    430: {
      slidesPerView: 1.1,
    },
    560: {
      slidesPerView: 2.15,
    },
    960: {
      slidesPerView: 3,
    },
  },
}
